export const systemAdminRole = 'systemAdminRole';
export const adminRole = 'adminRole';
export const basicRole = 'basicRole';